import {
  degreeDaysRecord,
  larvalTrendRecord,
  phenologyRecord,
  trapCatchesRecord,
} from 'stores/selectedValueGroupsStore/insectValueGroupRecords'
import type { TValueGroup } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { unitConverter } from 'utils/unitConverter/unitConverter'

const insectDegreeDaysForSaving = (val?: number | null) =>
  unitConverter.insectDegreeDaysCumulative(val, {
    inputUnit: userDetailsStore.getState().temperature === 'METRIC' ? 'c' : 'f',
    outputUnit: 'c',
  })

export const valueGroupsToUnitConverterFunctionForSaving: Record<
  TValueGroup,
  (typeof unitConverter)[keyof typeof unitConverter] | undefined // better to put undefined than to make this whole thing a partial
> = {
  air_temperature: (val?: number | null) =>
    unitConverter.temperatureInCanopy(val, {
      inputUnit: userDetailsStore.getState().temperature === 'METRIC' ? 'c' : 'f',
      outputUnit: 'c',
    }),
  almond_bloom: unitConverter.almondBloom,
  almond_hull_split: undefined,
  alternaria: unitConverter.alternariaCumulativeRolling7Days,
  atmospheric_pressure: undefined,
  bee_hours: (val?: number | null) => unitConverter.beeHours(val, undefined),
  cherry_powdery_mildew: undefined,
  chill: unitConverter.chillCumulativeHoursBelow45FSEP, // feels weird, since this'll change, but we'll change to using value-type definitions in the future
  conditions: undefined,
  wind_machine: unitConverter.windMachineTemperature,
  ...degreeDaysRecord(() => insectDegreeDaysForSaving),
  dew_point: (val?: number | null) =>
    unitConverter.dewPointInCanopy(val, {
      inputUnit: userDetailsStore.getState().temperature === 'METRIC' ? 'c' : 'f',
      outputUnit: 'c',
    }),
  equipment_status: undefined,
  evapotranspiration: (val?: number | null) =>
    unitConverter.evapotranspiration(val, {
      inputUnit: userDetailsStore.getState().rain === 'METRIC' ? 'mm' : 'in',
      outputUnit: 'mm',
    }),
  fire_blight: undefined,
  fruit_growth: unitConverter.fruitGrowth,
  grape_powdery_mildew: undefined,
  plant_stress: unitConverter.plantWaterStress,
  humidity: unitConverter.humidityInCanopy,
  irrigation_activity_pressure: undefined,
  irrigation_activity_zones: undefined,
  irrigation_activity_flow_meters: undefined,
  ...larvalTrendRecord(() => undefined),
  leaf_wetness: undefined,
  ndvi: undefined,
  precipitation: (val?: number | null) =>
    unitConverter.precipitation(val, {
      inputUnit: userDetailsStore.getState().rain === 'METRIC' ? 'mm' : 'in',
      outputUnit: 'mm',
    }),
  soil: unitConverter.soilAwc,
  spray_conditions: undefined,
  ...trapCatchesRecord(() => unitConverter.insectTrapCatches),
  ...phenologyRecord(() => unitConverter.insectPhenology),
  wet_bulb: (val?: number | null) =>
    unitConverter.wetBulbInCanopy(val, {
      inputUnit: userDetailsStore.getState().temperature === 'METRIC' ? 'c' : 'f',
      outputUnit: 'c',
    }),
  wind: (val?: number | null) =>
    unitConverter.windSpeed(val, {
      inputUnit: userDetailsStore.getState().speed === 'METRIC' ? 'kph' : 'mph',
      outputUnit: 'mps',
    }),
}
